import { FormDialog } from '@aibees/shared/components';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const Dialog = styled(FormDialog)``;
